import React from "react";

const USPBlockComponent = (props) => {
    const { Renderer } = props;

    return <Renderer {...props} />;
};

export default USPBlockComponent;
